<template>
  <section class="section-base">
    <div class="section-base__title-box">
      <div class="section-base__title">Уведомления</div>
      <div
        @click="onReadAllNotifications"
        v-if="isShowReadAllNotificationsButton"
        class="section-base__action-link"
      >
        Просмотреть все уведомления
      </div>
    </div>
    <div>
      <Notification ref="notification" />
    </div>
  </section>
</template>

<script>
import Notification from '@/components/elements/notifications/Notification';
import { NotificationModule } from '@/store/modules/notifications';

export default {
  name: 'Notifications',
  components: {
    Notification,
  },
  computed: {
    isShowReadAllNotificationsButton() {
      return NotificationModule.newCount > 0;
    },
  },
  methods: {
    onReadAllNotifications() {
      this.$refs.notification.readAllNotification();
    },
  },
};
</script>

<style scoped></style>
